<template>
	<div id="app">
		<router-view/>
	</div>
</template>

<script>
	import {getHost} from '@/utils'

	export default {
		name: 'App',
		data(){
			return {
				changeIcon:false
			}
		},
		computed: {
			site() {
				return this.$store.state.app.site
			}
		},
		created() {
			this.$nextTick(() => {
				let winHeight = window.innerHeight
				this.$store.dispatch('app/setVolumesMutation', winHeight)
			})
			let timer
			window.addEventListener('resize', () => {
				clearTimeout(timer)
				timer = setTimeout(() => {
					let winHeight = window.innerHeight
					this.$store.dispatch('app/setVolumesMutation', winHeight)
				}, 100)

			})

			let isMac = ["Mac68K", "MacPPC", "Macintosh", "MacIntel"].indexOf(navigator.platform) > -1 || navigator.userAgent.indexOf('Mac') > -1;
			if (!isMac) {
				let styleNode = document.createElement('style')
				let styleCon = `
					div ::-webkit-scrollbar {
					  width: 6px;
					  height: 6px; }

					div ::-webkit-scrollbar-button {
					  height: 0;
					  width: 0; }

					div ::-webkit-scrollbar-track {
					  background-color: #f1f1f1; }

					div ::-webkit-scrollbar-thumb {
					  background: #ccc; }
				`
				styleNode.type = 'text/css'
				if (styleNode.styleSheet) {
					styleNode.styleSheet.cssText = styleCon
				} else {
					styleNode.innerHTML = styleCon
				}
				document.getElementsByTagName('head')[0].appendChild(styleNode)
			}




			window.onbeforeunload = (e)=> {

				let curRouteName = this.$route.name
				if( curRouteName === 'addChapter' ||
					curRouteName === 'chapterPublished'||
					curRouteName === 'draft'
				){

					let res = this.$store.state.app.beforeClose()

					if(res===false){
						e = e || window.event;
						// 兼容IE8和Firefox 4之前的版本
						if (e) {
							e.returnValue = '关闭提示';
						}
						// Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
						return '关闭提示';
					}

				}
			}


		},
		watch:{
			site:{
				handler:function(val,oldVal){
					// 如果是醉唐 并且未修改过icon
					if(val === 'zuitang' && !this.changeIcon) {
						let linkEle = document.querySelectorAll('head link')
						for (let i = 0; i < linkEle.length; i++) {
							if (linkEle[i].rel === 'shortcut icon') {
								let oldhref = linkEle[i].href
								linkEle[i].href = oldhref.replace('favicon', 'static/ztfavicon')
								this.changeIcon = true
								break
							}
						}
					}

				},
				immediate:true
			}
		}
	}
</script>

<style lang="scss">
	/*全局app的css样式*/
	@import './styles/global.scss';


</style>
<style scoped lang="scss">
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
		height: 100%;
	}

</style>



// WEBPACK FOOTER //
// src/App.vue